import { FONT_TITLE, FONT_COLOUR_SCORE, FONT_COLOUR_SCORE_HIGH } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';
import * as Utils from 'utils/utils';

export default class HighScoreDisplay extends Phaser.Group {
  constructor({ game, score = 0 }) {
    super(game);

    this.frame = this.game.make.sprite(0, 0, 'ui', 'frame_highscore');
    this.add(this.frame);

    this.frameCenterY = this.frame.height * 0.5;

    this.starIcon = this.game.make.sprite(0, 0, 'ui', 'icon_highscore');
    this.starIcon.scale.set(30 / this.starIcon.height);
    this.starIcon.x = 40;
    this.starIcon.y = this.frame.height * 0.5 - this.starIcon.height * 0.5;
    this.add(this.starIcon);

    //  add copy
    this.copyDisplay = createTextField(this.game, FONT_TITLE, 38, FONT_COLOUR_SCORE_HIGH);
    this.copyDisplay.text = this.game.copy.getCopy('best').toUpperCase();
    this.copyDisplay.x = this.starIcon.x + this.starIcon.width + 20;
    this.copyDisplay.y = this.frameCenterY - this.copyDisplay.height * 0.5;
    this.add(this.copyDisplay);

    this.paperIcon = this.game.make.image(0, 0, 'ui', 'icon_paper');
    this.paperIcon.anchor.set(0, 0.5);
    this.paperIcon.x = this.frame.width * 0.5;
    this.paperIcon.y = this.frame.height * 0.5;
    this.paperIcon.scale.set(45 / this.paperIcon.height);
    this.add(this.paperIcon);

    // // add main score
    this.scoreDisplay = createTextField(this.game, FONT_TITLE, 54, FONT_COLOUR_SCORE_HIGH);
    this.scoreDisplay.x = this.paperIcon.x + this.paperIcon.width + 20;
    this.scoreDisplay.y = this.frame.height * 0.15;
    this.scoreDisplay.text = Utils.commaNumber(score);
    this.add(this.scoreDisplay);
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get width() {
    return this.frame.width;
  }
  get height() {
    return this.frame.height;
  }

  /*
  ============================================================================================
    SETTER
  ============================================================================================
  */

  setScore(value) {
    this.scoreDisplay.text = value;
    this.scoreTargetDisplay.x = this.scoreDisplay.x + this.scoreDisplay.width + 10;
  }

  /*
  ============================================================================================
    DESTROY
  ============================================================================================
  */

  destroy() {
    // destroy stuff - it's therapudic
    this.frame.destroy(true);
    this.starIcon.destroy(true);
    this.paperIcon.destroy(true);
    this.copyDisplay.destroy(true);
    this.scoreDisplay.destroy(true);
    // nullify it - GC flag :)
    this.frame = null;
    this.starIcon = null;
    this.paperIcon = null;
    this.copyDisplay = null;
    this.scoreDisplay = null;
    // super!!!!!
    super.destroy(true);
  }
}
